import ContextPanel from "@cayo/shared/components/surfaces/Panel/ContextPanel";
import Callout from "./Callout";
import Panel from "./Panel";

const contextpanel = (props: any) => <ContextPanel {...props} />;
const panel = (props: any) => <Panel {...props} />;
const callout = (props: any) => <Callout {...props} />;

const surfaceRenderers = {
  contextpanel,
  panel,
  callout,
};

export default surfaceRenderers;
